import { PLAYER_WIDTH, PLAYER_HEIGHT } from '../constants.js';

export class AABB {
  constructor(minX, minY, minZ, maxX, maxY, maxZ) {
    this.minX = minX;
    this.minY = minY;
    this.minZ = minZ;
    this.maxX = maxX;
    this.maxY = maxY;
    this.maxZ = maxZ;
  }

  static fromPlayer(x, y, z) {
    const hw = PLAYER_WIDTH / 2;
    return new AABB(
      x - hw, y, z - hw,
      x + hw, y + PLAYER_HEIGHT, z + hw
    );
  }

  clone() {
    return new AABB(this.minX, this.minY, this.minZ, this.maxX, this.maxY, this.maxZ);
  }

  translate(dx, dy, dz) {
    this.minX += dx; this.maxX += dx;
    this.minY += dy; this.maxY += dy;
    this.minZ += dz; this.maxZ += dz;
  }

  intersects(other) {
    return this.minX < other.maxX && this.maxX > other.minX &&
           this.minY < other.maxY && this.maxY > other.minY &&
           this.minZ < other.maxZ && this.maxZ > other.minZ;
  }

  getMin(axis) {
    if (axis === 0) return this.minX;
    if (axis === 1) return this.minY;
    return this.minZ;
  }

  getMax(axis) {
    if (axis === 0) return this.maxX;
    if (axis === 1) return this.maxY;
    return this.maxZ;
  }

  setMin(axis, val) {
    if (axis === 0) this.minX = val;
    else if (axis === 1) this.minY = val;
    else this.minZ = val;
  }

  setMax(axis, val) {
    if (axis === 0) this.maxX = val;
    else if (axis === 1) this.maxY = val;
    else this.maxZ = val;
  }
}
